import moment from 'moment';
import React, { CSSProperties, useEffect, useState } from 'react';
import { Row, Col, Form } from 'react-bootstrap';
//import SixMonthUsage from '../../data/consumer/SixMonthUsage.json';
import { getPastSixMonthData } from '../../services/consumer.service';

import PastSixMonths from '../charts/pastSixMonths';
import DotLoader from "react-spinners/DotLoader";

// Datepicker

const override: CSSProperties = {
  display: "block",
  margin: "auto",
  marginTop: "100px",
  borderColor: "red",
};

interface SixMonthUsageChartObject {
  startDate: string,
  endDate: string,
  bill: {
    traded: number,
    energy_load: number
  },
  usage: {
    traded: number,
    energy_load: number
  }
}

const PastSixMonthsWidget = (props: any) => {
  const [isChecked, setIsChecked] = useState(false);
  const [data, setData] = useState<SixMonthUsageChartObject[]>([])
  let [loading, setLoading] = useState(false);
  const color = "#006837";
  const auth = JSON.parse(localStorage.getItem('auth')!)
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const data = await getPastSixMonthData(auth?.userId, 1, props.userList);
      setData(data.data);
      setLoading(false);
    }
    fetchData();
  }, [props.userList])

  //get Traded data kWh
  const tradeDatakWh = data.map((data) => data.usage.traded);
  // get Energy Load data kWh
  const energyLoadDatakWh = data.map((data) => data.usage.energy_load);
  // get Traded data Bill
  const tradeDataBill = data.map((data) => data.bill.traded);
  // get Energy Load data Bill
  const energyLoadDataBill = data.map((data) => data.bill.energy_load);

  let tradeData = tradeDatakWh;
  let energyLoadData = energyLoadDatakWh;

  // 24 hours period
  if (!isChecked) {
    tradeData = tradeDatakWh;
    energyLoadData = energyLoadDatakWh;
  } else {
    tradeData = tradeDataBill;
    energyLoadData = energyLoadDataBill;
  }

  //get Labels 
  const daylabels = data.map((data) => moment(data.startDate).format("MMM’YY"));

  return (
    <div className='dashboardWidget'>
      <div className='widgetTitle'>
        <Row>
          <Col md="9"><h3>Past 6 Months Usage</h3></Col>
          <Col md="3">
            <div className='d-flex align-items-center justify-content-end'>
              <span className='d-block me-2'>kWh</span> <Form.Check type="switch" id="s6muks" label="" onClick={() => setIsChecked(!isChecked)} /> <span className='d-block ms-2'>฿</span>
            </div>
          </Col>
        </Row>
      </div>
      <div className='widgetBody'>
        {loading ? <DotLoader
          color={color}
          loading={loading}
          cssOverride={override}
          size={50}
          aria-label="Loading Spinner"
          data-testid="loader"
        /> :
          <div>
            <PastSixMonths isChecked={isChecked} labels={daylabels} tradeData={tradeData} energyLoadData={energyLoadData} />
          </div>
        }
      </div>
    </div>
  )
}
export default PastSixMonthsWidget;